<template lang="pug">
div
  .entity-search
    app-criteria-builder(ref="criteria-builder", :entity="entity", @changeInitial="$emit('changeInitial',$event)", @criteria="searchEntries", :initialCriterias="criteria", :disabled="disabled")
</template>

<script>
import axios from 'axios'

export default {
  name: 'entity-search',
  props: ['withoutBusinessScopeFilter', 'criteria', 'entity', 'init', 'loads', 'loadExtraDatas', 'wheres', 'disabled', 'value', 'rowsPerPage', 'errorMessages', 'endpoint'],
  data () {
    return {
      localValue: this.value,
      timer: 0,
      wait: 500,
      pagination: {
        data: this.init && this.init.uid
          ? [this.init]
          : this.value
            ? [this.value]
            : []
      },
      searchField: this.entity.fields ? this.entity.fields[0].name !== 'uid' ? this.entity.fields[0].name : this.entity.fields[1].name : '',
    }
  },
  watch: {
    localValue (value) {
      this.$emit('input', { ...value, entityState: value._Entity != 'BusinessScope' ? 3 : value.entityState})
    }
  },
  computed: {
    where () {
      if (this.wheres !== undefined && Array.isArray(this.wheres)) return [...this.wheres, ...this.$refs['criteria-builder'].criterias.map((c) => c.value) ]
      return [...this.$refs['criteria-builder'].criterias.map((c) => c.value) ]
    },
  },
  methods: {
    getResultText(x) {
      return x.name || x.externalId || x.uid
    },
    async searchEntries (search) {
      if (!this.bounce) {
        this.pagination = (await axios.get(this.endpoint || this.entity.name, {
          params: {
            withoutGlobalBusinessScope: !!this.withoutBusinessScopeFilter,
            pageSize: this.rowsPerPage || 50,
            where: this.where,
            load: this.loads,
            loadExtraData: this.loadExtraDatas
          }
        })).data
        this.$emit('pagination', this.pagination)
        return
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        this.pagination = (await axios.get(this.endpoint || this.entity.name, { params: { pageSize: 100, where: this.where }})).data
        this.$emit('pagination', this.pagination)
      }, this.wait)
    },
  },

  mounted () {
    //
    if (this.localValue === null && this.init && this.init.uid) this.localValue = this.init
  }
}
</script>
